import Vue from 'vue'
import CPEmoji from '../scripts/CPEmoji'
import EmojiData from 'emoji-mart-vue/data/facebook.json'
import SessionManager from '../Manager/Session.manager'
import config from './config';

let arrEmojiID = []
let arrEmojiOImg = []


export class CPUtils {
  constructor(){}

  static ScrollChatMessagesToEnd() {
    setTimeout(function(){
      var container = document.querySelector("#chat_queue")
      if(container != null){
        container.scrollTop = container.scrollHeight
      }
    },0)
  }

  static scroll(container, scrollLength){
    setTimeout(function(){
      if(container != null){
          container.scrollTop = scrollLength
      }
    },0)
  }
  static hasBR(text){
    if(text.match(config.LINE_BREAK_REG)){
      return true
    }

    return false
  }

  static hasBold(text){
    if(text.match(config.BOLD_REG)){
      return true;
    }
    return false;
  }

  static hasItalic(text){
    if(text.match(config.ITALIC_REG)){
      return true;
    }
    return false;
  }


  static hasStrike(text){
    if(text.match(config.STRIKE_REG)){
      return true;
    }
    return false;
  }

  static hasEmoji(text){
    if(typeof text != 'undefined' &&
      text.match(config.EMOJI_REG)){
      return true;
    }
    return false;
  }
  static hasEmail(text){
    if(typeof text != 'undefined' &&
    text.match(config.EMAIL_REG)){ //\S+@\S+\.\S*[^\|]
      return true
    }
    return false
  }

  static hasMention(text){
    if(typeof text != 'undefined' &&
    text.match(config.MENTION_REG)){
        return true;
      }
    return false;
  }

  //@TODO ti has to be adapted to better regex
  static hasURL(text){
    if(typeof text  != 'undefined' &&
    text[text.search(config.URL_REG)-1] !='/'&&
    text[text.search(config.URL_REG)-1] !='\\'&&
    text.match(config.URL_REG)){
      return true
    }
    return false
  }
  static getURLPosition(text){
    return text.search(config.URL_REG)
  }
  static getEmailPosition(text){
    return text.search(config.EMAIL_REG)
  }
  static getURL(text){
    // text = text.replace(/\n/g, '')
    let URLPosition = text.search(config.URL_REG)
    let reg = new RegExp(config.URL_REG)
    if(text[URLPosition-1] !='/'&& text[URLPosition-1] !='\\'){
      let matches = text.match(reg)
      let urlStart = text.slice(URLPosition)
      if(matches != null){
        urlStart = text.slice(URLPosition, URLPosition+matches[0].length)
      }
        while(urlStart.indexOf("\\n") > -1){
          urlStart = urlStart.slice(0, urlStart.indexOf("\\n")-1)
        }

        while(urlStart.indexOf(" ") > -1){
          urlStart = urlStart.slice(0, urlStart.indexOf(" "))
        }

        while(urlStart.indexOf("&nbsp;") > -1){
          urlStart = urlStart.slice(0, urlStart.indexOf("&nbsp;"))
        }
        return urlStart
    }else {
      return text
    }
  }

  static getAllUrls(text) {
      let urlsArray = [];
      let computedText = text;
      while (CPUtils.hasURL(computedText)) {
          const URL = CPUtils.getURL(computedText);
          urlsArray.push(URL);
          computedText = computedText.slice(computedText.indexOf(URL) + URL.length);
      }
      return urlsArray;
  }

  static getEmail(text){
    let EmailPosition = text.search(config.EMAIL_REG)
    let emailStart = text.slice(EmailPosition)
    while(emailStart.indexOf("|") > -1){
      emailStart = emailStart.slice(0, emailStart.indexOf("|"))
    }

    while(emailStart.indexOf(" ") > -1){
      emailStart = emailStart.slice(0, emailStart.indexOf(" "))
    }

    while(emailStart.indexOf("&nbsp;") > -1){
      emailStart = emailStart.slice(0, emailStart.indexOf("&nbsp;"))
    }
    return emailStart
  }

  static log (data){
    serverBus.$emit('log', data);
  }
  //@TODO more restricted *::*
  static findEmoji(text){
    if(typeof text  === 'string' && text.match(config.EMOJI_REG) != null){
      let emStart = text.slice(text.search(config.EMOJI_REG)+1); // we don't need for return
      let emojiCode = emStart.slice(0, emStart.search(/:/g));
      let rest = text.slice(text.search(config.EMOJI_REG)+ emojiCode.length+2, text.length);
      return {'emoji': emojiCode, 'rest': rest};
    }
    return null;
  }

  static hasComponentAttached(text){
    if(this.hasEmoji(text) ||
      this.hasURL(text) ||
      this.hasMention(text)
    ){
      return true
    }
    return false
  }
  static getSegmentType(text){
    switch(true){
      case this.hasEmoji(text):
        return "emoji"
      case this.hasURL(text):
        return "URL"
      case this.hasEmail(text):
        return "email"
      case this.hasMention(text):
        return "mention"
      case this.hasBR(text):
        return "BR"

      default:
      return "text"
    }
  }



  static getStylingChars(){
    return Object.keys(config.MESSAGE_TEXT_STYLE)
  }
  /**
   * Remove logged in user from given array
   *
   */
  static RemoveLoggedInUser(arr){
    let new_arr = []
    for(let i = 0;i < arr.length; i++){
      if(typeof arr[i] != 'undefined' && arr[i].user_id != SessionManager.getLoggedInUserId()){
        new_arr.push(arr[i])
      }
    }
    return new_arr
  }

  /**
   * String equality
   */
  static equals(a, b){
    let i = a.length
    while(i >= 0){
      if(a[i] == b[i]){
        if(i == 0){
          return true
        }
      }
      i--
    }
    return false
  }

  /**
   * remove from array
   */
  static RemoveFromArray(from, a){
    for(let i =0 ; i< from.length-1; i++){
      if(from[i] == a){
        from = from.splice(i, 1)
      }
    }
    return from
  }

//@TODO use it carfully double check
  static HasTextStyling(text){
    // if (CPUtils.hasBold(text)) {
    //   return true
    // }
    // if (CPUtils.hasItalic(text)) {
    //   return true
    // }
    // if (CPUtils.hasStrike(text)) {
    //   return true
    // }
    // if (CPUtils.hasBR(text)) {
    //   return true
    // }

    return false
  }


/**
 *
 * handle styling of text and line breaks
 */
  static GetMessageDecodeDisplay(inputFeed){
    inputFeed = inputFeed.trim()
    let decodedStyleMessage = []
    let specialChar = ''
    let specialCharAt = -1
    let checkSpecialCharInForm =  false
    let stringBuffer = ''

      for(let letterPos=0; letterPos<inputFeed.length;letterPos++){
        if(inputFeed[letterPos] in config.MESSAGE_TEXT_STYLE &&
          (letterPos == 0 || (letterPos > 0 && specialChar == '' &&
          inputFeed[letterPos-1].trim() == ''))){
              specialChar = inputFeed[letterPos]
              specialCharAt = letterPos
        }

        if(inputFeed[letterPos] == '\n'){
          decodedStyleMessage.push({
            style: 'none',
            text: stringBuffer
          })
          stringBuffer = ''
          decodedStyleMessage.push({style: 'lbreak',text:  "" })
          continue
        }

        if(specialCharAt == -1){
          stringBuffer += inputFeed[letterPos]
        }else {
          decodedStyleMessage.push({
            style: 'none',
            text: stringBuffer
          })
          stringBuffer = ''
        }

        checkSpecialCharInForm = (letterPos == inputFeed.length-1) || (letterPos< inputFeed.length-1 && inputFeed[letterPos+1].trim() == '')

        // if(specialChar != '' && inputFeed[letterPos] != specialChar)
        //   continue

        if(letterPos > 0 && specialChar != '' &&
            inputFeed[letterPos] in config.MESSAGE_TEXT_STYLE &&
            inputFeed[letterPos] == specialChar &&
            checkSpecialCharInForm){

              decodedStyleMessage.push({
                style: config.MESSAGE_TEXT_STYLE[specialChar],
                text: inputFeed.slice(specialCharAt, letterPos+1),
              })


              specialChar = ''
              specialCharAt = -1
              continue
        }
        // case unclosed style
        if(specialChar != '' && letterPos == inputFeed.length-1){
          decodedStyleMessage.push({
            style: 'none',
            text: inputFeed.slice(specialCharAt, letterPos)
          })
        }
      }
      if(stringBuffer.length > 0){
        decodedStyleMessage.push({
          style: 'none',
          text: stringBuffer
        })
        stringBuffer = ''
      }
    return decodedStyleMessage
  }


  static GetURLHTML (text){
    let result = ''
      // while(CPUtils.hasURL(text)) {
      //   let urlPos = CPUtils.getURLPosition(text)
      //   let url = CPUtils.getURL(text)
      //   let urlRef = url

      //   if(CPUtils.hasEmail(url)) {
      //     urlPos = CPUtils.getEmailPosition(text)
      //     url = CPUtils.getEmail(text)
      //     urlRef = "mailto://" + url
      //   }

      //   if (urlRef.indexOf('http') == -1 && !CPUtils.hasEmail(url)) {
      //     urlRef = "http://" + url
      //   }
      //   if(text[urlPos+ url.length].match(/\n/g) != null){ // for \n beside url
      //     result += "<br/>"
      //   }
      //   result += ' <a  href="' + urlRef + '" target="_blank" class="link">' + url + '</a> ' //text.slice(0, urlPos) +
      //   // text = text.slice(urlPos + url.length)
      // }

      return text
  }


  static getEmojiIMG(emojiID){
    let found = false
    if (!arrEmojiID.includes(emojiID)) {
      arrEmojiID.push(emojiID)
      for(let i=0;i<EmojiData.categories.length;i++){
        if (EmojiData.categories[i].emojis.includes(emojiID)) {
          found = true
          break
        }
      }
      if (found) {
        const EmojiClass = Vue.extend(CPEmoji);
        const vm = new EmojiClass({
          propsData: {
            emo: emojiID,
          }
        }).$mount()
        let emojiHTML = vm.$el
        let img = {
          src: "data:image/png;base64,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",
          alt: emojiID,
          style: 'background-position: ' + emojiHTML.firstChild.style.backgroundPosition
        }
        arrEmojiOImg.push(img)
        return img
      }
    } else {
      return arrEmojiOImg.find(elem => {
        return elem.alt == emojiID
      })
    }
  }

  static ValidateUsername(text){
    if(text.indexOf('@') > -1){
      return false
    }

    if(text.indexOf('.') > -1){
      return false
    }

    if(text.indexOf('/') > -1){
      return false
    }

    if(text.indexOf('\\') > -1){
      return false
    }

    if(text.indexOf('$') > -1){
      return false
    }

    if(text.indexOf(' ') > -1){
      return false
    }

    if(text.indexOf('\"') > -1){
      return false
    }

    if(text.indexOf('\'') > -1){
      return false
    }

    if(text.indexOf(':') > -1){
      return false
    }

    if(text.indexOf(',') > -1){
      return false
    }

    if(text.indexOf(';') > -1){
      return false
    }
    return true
  }

  static ValidatePassword(password){
    if(password.length < 8){
      return false
    }
    // search for CAPITAL chars
    if(password.search(/[A-Z]/g) == -1){
      return false
    }
    // search for small chars
    if(password.search(/[a-z]/g) == -1){
      return false
    }
    // search for symbol chars
    if(password.search(/[-!$%^&*()#_+|~=`{}\[\]:";'<>?,.\/]/g) == -1){
      return false
    }

    return true
  }


  static ValidateChannelName(text){
    if(text.indexOf('@') > -1){
      return false
    }

    if(text.indexOf('.') > -1){
      return false
    }

    if(text.indexOf('/') > -1){
      return false
    }

    if(text.indexOf('\\') > -1){
      return false
    }

    if(text.indexOf('$') > -1){
      return false
    }

    if(text.indexOf('\"') > -1){
      return false
    }

    if(text.indexOf('\'') > -1){
      return false
    }

    if(text.indexOf(':') > -1){
      return false
    }

    if(text.indexOf(',') > -1){
      return false
    }

    if(text.indexOf(';') > -1){
      return false
    }
    return true
  }


  static getDurationByDay(){
    let duration = []
    let day  = 24*60*60 // day on ms
    let i= 1
    while(i<7){
      let s = "s"
      if(i == 1){
        s = ''
      }
      duration.push({
        'value': day*i,
        'text': i + " day" + s
      })
      i++
    }

    i=7
    while(i<63){
      let s = "s"
      if(i == 7){
        s = ''
      }
      duration.push({
        'value': day*i,
        'text': i/7 + " week" + s
      })
      i +=7
    }

    duration.push({
      'value': 99999999999,
      'text': 'infinite'
    })
    return duration
  }

  static isTabActive(){
    if (typeof document.hidden !== "undefined") { // Opera 12.10 and Firefox 18 and later support
      return !document.hidden
    } else if (typeof document.msHidden !== "undefined") {
      return !document.msHidden
    } else if (typeof document.webkitHidden !== "undefined") {
      return !document.webkitHidden
    }
  }
}
